import { useStyles } from '../../hooks/useStyles';
import { TimelineEvent } from '../../types/app';

type Props = {
  events: TimelineEvent[];
}

const Timeline = ({ events }: Readonly<Props>) => {
  const { css, theme } = useStyles();

  return (
    <div className={css({
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      position: "relative",
    })}>
      {events.map((event, index) => (
        <div key={index} className={css({
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          marginBottom: "20px",
          width: "100%",
          ":before": {
            content: "'|'",
            position: "absolute",
            left: "50%",
            top: "26px",
            transform: 'translateX(-50%)',
            width: "2px",
            height: "100%",
            background: "#dddddd",
            color: "transparent",
          },
          ":last-child::before": {
            content: "none"
          }
        })}>
          <div className={css({
            display: "flex",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            gap: "35px",
          })}>
            <div className={css({
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "end",
              textAlign: 'end',
              ...theme.typography.LabelSmall
            })}>
              {event.label}
            </div>
            <div className={css({
              display: "flex",
              width: "100%",
              ...theme.typography.LabelXSmall,
            })}>
              <div className={css({
                padding: '5px 10px',
                backgroundColor: theme.colors.backgroundTertiary,
                borderRadius: '5px'
              })}>
                {event.date}
              </div>
            </div>
          </div>
          <div className={css({
            position: "absolute",
            transform: 'translateX(-50%)',
            left: "50%",
            width: "7px",
            height: "7px",
            borderRadius: "50%",
            border: "5px solid black"
          })} />
        </div>
      ))}
    </div>
  );
};

export default Timeline;
